



























































































































import { Component, Vue } from "vue-property-decorator";
import Airport from "@/store/entities/flight/airport";
@Component({})
export default class FlightOrderChangeModal extends Vue {
  dialog: boolean = true;
  startDate: Date = null;
  headersFlightSearch: any[] = [];
  mockDataFlightSearch: any[] = [];
  radio: boolean = true;
  airports: Airport[] = [];
  fromAirports: any={};
  toAirports: any={};
  filterData(item, queryText) {
  
  return (
    item.id.toLowerCase().includes(queryText.toLowerCase()) ||  
    item.name.toLowerCase().includes(queryText.toLowerCase())
  );
}

  created() {
    console.log("modelden geldi",this.$store.state.flight.selectedFlightOrder);
    this.fromAirports=this.$store.state.flight.selectedFlightOrder.fromAirportId;
    this.toAirports=this.$store.state.flight.selectedFlightOrder.toAirportId;
    this.getAirports();
    (this.headersFlightSearch = [
      { text: "", value: "" },
      { text: "Havayolu Adı", value: "company" },
      { text: "Başlangıç-Varış", value: "destination" },
      { text: "Uçuş Numarası", value: "flightNumber" },
      { text: "Kalkış Tarihi", value: "departureDate" },
      { text: "Varış Tarihi", value: "arrivalDate" },
    ]),
      (this.mockDataFlightSearch = [
        {
          company: "URAL AIRLINES ",
          destination: "AER - DME",
          flightNumber: "U6 1518  ",
          departureDate: "15/05/2021 17:10",
          arrivalDate: "15/05/2021 19:30 ",
        },
      ]);
  }



    async getAirports() {
    await this.$store.dispatch({
      type: "airport/getAirports",
    });

    this.airports = this.$store.state.airport.list;
  }


  closeDialog() {
    this.$emit("closed");
  }
}
